import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';

const CurrentVersionField = ({ record = {} }) => (
  <Typography
    variant="body1"
  >
    {record.current_major_version === null && (
      'new'
    )}
    {typeof record.current_major_version === 'number' && (
      <>
        v
        {record.current_major_version}
        .
        {record.current_minor_version}
      </>
    )}
  </Typography>
);

CurrentVersionField.propTypes = {
  record: PropTypes.object,
};

CurrentVersionField.defaultProps = {
  addLabel: true,
  label: 'Current Version',
};

export default CurrentVersionField;

